import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import type { IframeComponentType } from '@unifyapps/defs/blocks/Iframe/types';
import Iframe from './Iframe';

class IframeBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return Iframe;
  }

  get type(): ComponentTypeUnionType {
    return 'Iframe';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component as IframeComponentType, [
          'content',
          'appearance',
          'componentType',
        ]),
      }) as BlockStateUnionType;
  }
}

export default IframeBlockStateDefinition;
